import styled from 'styled-components';

import BiggbyCardLayoutImage from '../../../../assets/imgs/BIGGBY_Card.svg';
import STAR from '../../../../assets/imgs/star-active.svg';
import { Flex } from '../../../../GlobalComponents/Flex';
import { Icon } from '../../../../GlobalComponents/Icon';

const CardListView = ({
	cardDetails,
	onOpenCard
}: CardListViewProps): JSX.Element => {
	return (
		<Flex $flexDirection="column" $rowGap="24px">
			{cardDetails.map(
				({ id, card_number, cash, default_payment_method }, index) => (
					<Flex
						$flexDirection="column"
						key={id}
						onClick={() => onOpenCard(cardDetails[index])}
						id={default_payment_method ? 'default' : 'not-default'}
					>
						<Flex $flexDirection="row" $margin="0 0 24px 0">
							<img
								height={80}
								width={130}
								src={BiggbyCardLayoutImage}
								alt="BIGGBY Card"
							/>
							<Flex
								$flexDirection="column"
								$placeContent="flex-start space-between"
								$alignItems="flex-start"
								$margin="0 0 0 8px"
								$height="80px"
								$padding="8px 2px"
							>
								<Flex
									$flexDirection="row"
									$columnGap="8px"
									$alignItems="flex-start"
								>
									<CardNumber>{card_number}</CardNumber>
									{default_payment_method && (
										<Icon
											$url={STAR}
											alt="favorite"
											$width={15}
											$height={15}
										/>
									)}
								</Flex>

								<Flex
									$flexDirection="row"
									$placeContent="flex-start space-between"
									$alignItems="flex-start"
									$height="unset"
								>
									<Balance>Balance</Balance>
									<Balance>$ {cash}</Balance>
								</Flex>
							</Flex>
						</Flex>
						<Divider />
					</Flex>
				)
			)}
		</Flex>
	);
};

export default CardListView;

const Divider = styled.div`
	border: 0.5px solid #dcdcdc;
`;

const CardNumber = styled.div`
	font-size: 16px;
	line-height: 100%;
	color: #575757;
	font-weight: 700;
`;

const Balance = styled.div`
	font-size: 16px;
	line-height: 100%;
	color: #575757;
	font-weight: 700;
`;

interface CardListViewProps {
	cardDetails: Card[];
	onOpenCard: (card: Card) => void;
}
